<template lang="html">
<footer class="c2h4-footer__logo" ref="footer">
  <img class="c2h4-img__logo" :src="logo" alt="你今天真好看APP，轻松拍照测肤质" />
</footer>
</template>

<script>
import logo from '../../../assets/logo.jpg'
export default {
  data () {
    return {
      logo: logo
    }
  }
}
</script>

<style scoped>
.c2h4-footer__logo{
  width: 100%;
  heigth: 31.46vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.c2h4-img__logo{
  width: 31.2vw;
  padding-bottom: 9.6vw;
  padding-top: 11.7vw;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer/index.vue